export default __webpack_public_path__ + "static/media/002.5b3bc2bb.jpg";